import React, { useEffect, useState } from "react";
import {
  Modal,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const ModalCreateVendor = ({ show, onClose, onSave }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [link, setLink] = useState("");

  const [validLink, setValidLink] = useState(false);
  const [resolvedLink, setResolvedLink] = useState(null);

  useEffect(() => {
    if (!link || link.trim() === "") {
      setValidLink(false);
      setResolvedLink(null);
      return;
    }

    const trimmed = link.trim();

    // Si no trae protocolo, asumimos http://
    const normalizedValue = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `http://${trimmed}`;

    try {
      const url = new URL(normalizedValue);
      if (url.protocol === "http:" || url.protocol === "https:") {
        setValidLink(true);
        setResolvedLink(normalizedValue);
        return;
      }
    } catch {
      // noop
    }

    setValidLink(false);
    setResolvedLink(null);
  }, [link]);

  const handleSave = () => {
    if (name.trim() && validLink && resolvedLink) {
      // Guardamos el link ya normalizado
      onSave({ name: name.trim(), link: resolvedLink });
      setName("");
      setLink("");
      onClose();
    }
  };

  const handleClose = () => {
    setName("");
    setLink("");
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t(`clinicalTrials.addVendorModal.modalTitle`)}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormGroup controlId="formName">
          <ControlLabel>
            {t(`clinicalTrials.addVendorModal.nameLabel`)}{" "}
            <span className="text-danger">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            placeholder={t(`clinicalTrials.addVendorModal.namePlaceholder`)}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FormGroup>

        <FormGroup controlId="formLink">
          <ControlLabel>
            {t(`clinicalTrials.addVendorModal.linkLabel`)}{" "}
            <span className="text-danger">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            placeholder="https://..."
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />

          {link.trim() !== "" && !validLink && (
            <div
              style={{ marginTop: "6px", fontSize: "12px", color: "#dc3545" }}
            >
              {t(`clinicalTrials.addVendorModal.invalidLinkMessage`)}
            </div>
          )}

          {validLink && resolvedLink && (
            <div
              style={{ marginTop: "6px", fontSize: "12px", color: "#6c757d" }}
            >
              {t(`clinicalTrials.addVendorModal.validLinkMessage`)}{" "}
              {resolvedLink}
            </div>
          )}
        </FormGroup>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          {t(`clinicalTrials.addVendorModal.cancelButtonLabel`)}
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!name.trim() || !validLink}
          title={
            !validLink
              ? t(`clinicalTrials.addVendorModal.acceptButtonTooltip`)
              : undefined
          }
        >
          {t(`clinicalTrials.addVendorModal.acceptButtonLabel`)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
